module.exports = __webpack_public_path__ + "img/19.23cb0ac7.jpg";